import slugify from "slugify";
import './request-callback';
import './assistant';
import './profile';

window.defaultIntlTelInput = {
    separateDialCode: true,
    preferredCountries: ["ae"],
    excludeCountries: ["am", "az", "ge", "de", "id", "kz", "kg", "ua", "uz", "tj"],
    autoPlaceholder: "Enter Mobile Number",
};

window.dashboardApiAxios = axios.create({
    baseURL: APP_API_URL,
});

window.mainApiAxios = axios.create({
    // baseURL: APP_BASE_URL,
    baseURL: APP_API_URL,
});


window.dashboardApiAxios.defaults.headers.common['X-Requested-With'] = null;
// window.mainApiAxios.defaults.headers.common['X-Requested-With'] = null;

window.openLoginModal = () => {
    $('#loginModal').modal('show');
}

window.selectSchoolType = (event) => {
    event.preventDefault();
    let selectedElement = $(event.target);
    if (!selectedElement.hasClass('active')) {
        selectedElement.closest('.dropdown-menu').prev().text(selectedElement.text());
        selectedElement.closest('.dropdown-menu').find('.dropdown-item').removeClass('active');
        selectedElement.addClass('active');
    }
}


window.submitSchoolSearch = (locationData, schoolTypeSlug) => {
    localStorage.setItem('user_search_location', JSON.stringify(locationData));
    let proceedToSearch = true;
    if (!locationData) {
        toastr.error('', 'Please type location', {
            "positionClass": "toast-bottom-center",
            "showDuration": "5000",
            "hideDuration": "5000"
        });
        proceedToSearch = false;
    }

    if (!schoolTypeSlug) {
        toastr.error('', 'Please Select School Type', {
            "positionClass": "toast-bottom-center",
            "showDuration": "5000",
            "hideDuration": "5000"
        });
        proceedToSearch = false;
    }

    if (!proceedToSearch) return false;

    let place_level = locationData.address_components[0].types[0];
    let place_lat = locationData.geometry.location.lat();
    let place_lng = locationData.geometry.location.lng();

    let filteredFormattedAddressData = filterGoogleMapApiResponse(locationData);
    let filteredFormattedAddressDataStr = filteredFormattedAddressDataSlug(locationData);


    let placeLevel = '';
    let localityObj = locationData.address_components.filter((v, i) => {
        if (v.types[0] === 'locality') return v;
    });

    let administrativeAreaLevel1 = locationData.address_components.filter((v, i) => {
        // console.log(v.types[0]);
        if (v.types[0] === 'administrative_area_level_1') return v;
    });

    let administrativeAreaLevel2 = locationData.address_components.filter((v, i) => {
        // console.log(v.types[0]);
        if (v.types[0] === 'administrative_area_level_2') return v;
    });
    let countryObj = locationData.address_components.filter((v, i) => {
        if (v.types[1] === 'country') return v;
    });

    let formatted_address = locationData.formatted_address;
    formatted_address = slugify(formatted_address);

    let cityText = '';

    if (localityObj.length) {
        // cityText = localityObj[0].long_name.toLowerCase();
        cityText = filteredFormattedAddressData.city.toLowerCase();
    }


    let locality = '';
    if (filteredFormattedAddressData.hasOwnProperty('locality')) {
        if (!!filteredFormattedAddressData.locality && filteredFormattedAddressData.locality.length) {
            placeLevel = localityObj[0].types[0];
            locality = filteredFormattedAddressData.locality[filteredFormattedAddressData.locality.length - 1];
        }
    }

    let city_2_name = '';
    if (administrativeAreaLevel2.length) {
        city_2_name = slugify(administrativeAreaLevel2[0].long_name);
        // if(!placeLevel) placeLevel = administrativeAreaLevel2[0].types[0];
    }

    let state_name = "";
    if (!!administrativeAreaLevel1.length) {
        // state_name = slugify(administrativeAreaLevel1[0].long_name);
        state_name = slugify(filteredFormattedAddressData.state);
        if (!placeLevel && !cityText) placeLevel = administrativeAreaLevel1[0].types[0];
    }

    let country_name = "";
    if (!!administrativeAreaLevel1.length) {
        // state_name = slugify(administrativeAreaLevel1[0].long_name);
        country_name = slugify(filteredFormattedAddressData.country);
    }

    let searchSessionData = {
        'locality': localityObj,
        'administrativeAreaLevel1': administrativeAreaLevel1,
        'administrativeAreaLevel2': administrativeAreaLevel2,
        'city_name': cityText,
        'city_2_name': city_2_name,
        'state_name': state_name,
        'country_name': country_name,
        'formattedAddress': formatted_address,
        'latitude': place_lat,
        'longitude': place_lng,
        'placeLevel': placeLevel,
    };

    let redirectUrl = filteredFormattedAddressDataStr;
    let encodedecode = btoa(place_lat + "," + place_lng);
    window.location.href = `${APP_URL}/search/${schoolTypeSlug}/${formatted_address.toLowerCase()}-${encodedecode}${redirectUrl.length ? '/?' + redirectUrl : ''}`;
}

window.filterGoogleMapApiResponse = (data) => {
    const {
        address_components = [], formatted_address = "", name = "", geometry = {}
    } = data || {};

    const geo_info = {};

    address_components.forEach(({long_name = null, types: [type = null] = []}) => geo_info[type] = long_name);

    const {
        country = null, postal_code = null, locality = null, administrative_area_level_1 = null,
        administrative_area_level_2 = null, administrative_area_level_3 = null
    } = geo_info;

    let state = administrative_area_level_1;
    let district = administrative_area_level_2;
    let city = administrative_area_level_3 || locality;


    return {...geo_info, country, state, district, city, postal_code, name, formatted_address, geometry, locality};
}

window.insertSearchApi = (SearchParameter) => {
    mainApiAxios.post('/searches/index.php?action=insert', SearchParameter).then(res => {
        console.log('Recent Searches Successfully added');
    }).catch(err => console.log(err));
}

window.filteredFormattedAddressDataSlug = (searchLocationPlaces) => {
    if (searchLocationPlaces.length > 0) return false;
    let filteredFormattedAddressData = filterGoogleMapApiResponse(searchLocationPlaces);
    let filteredFormattedAddressDataStr = '';

    for (let filterName in filteredFormattedAddressData) {
        if (['geometry', 'postal_code', 'plus_code'].indexOf(filterName) >= 0) continue;
        if (!!filteredFormattedAddressData[filterName]) filteredFormattedAddressDataStr += `${filterName}=${slugify(filteredFormattedAddressData[filterName], {lower: true})} `;
    }
    filteredFormattedAddressDataStr = filteredFormattedAddressDataStr.trim().split(' ').join('&');
    return filteredFormattedAddressDataStr;
}

window.getSchoolTypeSearchText = ($schoolType) => {
    $schoolType = parseInt($schoolType);
    if ($schoolType === 1) return 'day-school';
    else if ($schoolType === 2) return 'pre-school';
    else if ($schoolType === 3) return 'boarding-school';
    else if ($schoolType === 5) return 'pu-junior-colleges';
    else if ($schoolType === 4) return 'day-care';
}

/**
 *
 * @param phone int
 * @param countryCode str
 * @returns {boolean}
 */
window.verifyPhoneNumberFromGoogleScript = (phone, countryCode) => {
    let libphonenumber_API = new libphonenumber.PhoneNumberUtil();
    countryCode = countryCode.toUpperCase();
    const phn = libphonenumber_API.parse(phone, countryCode);
    const possible = libphonenumber_API.isPossibleNumber(phn);
    const valid = libphonenumber_API.isValidNumber(phn);
    let response = false;
    if (!!valid && !!possible) response = true;

    // if(DEBUG) console.log(possible, valid, countryCode);

    return response;
}

window.scrollToTop = (selector, offset = 80) => {
    $('html, body').animate({
        scrollTop: selector.offset().top - offset
    }, 500);
}

$(function () {
    const languages = {
        "en": "English", "fr": "French", "es": "Spanish", "zh": "Chinese",
        "de": "German", "hi": "Hindi", "bn": "Bengali", "ta": "Tamil",
        "ru": "Russian", "ml": "Malayalam", "ar": "Arabic"
    }

    let selectedLang = 'EN';
    for (const key in languages) {
        if (window.location.href.includes(`${key}/uae`)) {
            selectedLang = key.toUpperCase();
            break; // Once we find a matching key, we can stop searching
        }
    }
    $('#langSelected').html(selectedLang);
    $('#registerSchoolBtn').on('click', async function (e) {
        e.preventDefault();
        $('#enquireForSchoolModal').modal('show');
    });

    $('#headerNavSearch').on('click', async function (e) {
        e.preventDefault();
        let schoolType = $('#headerSchoolSearchWrapper .school-type-single.active');
        // if (DEBUG) console.log(headerSchoolSearchLocationPlaces);
        headerSearchAnalytics(schoolType.text());
        submitSchoolSearch(headerSchoolSearchLocationPlaces, schoolType.attr('data-schooltypeslug'));
    })
});

window.excerptContent = (readMoreText = 'read more', readLessText = 'read less') => {
    $('.expert-comment-link').off('click').on('click', function (e) {
        e.preventDefault();
        let readMoreButton = $(this);
        let schoolId = readMoreButton.attr('data-id');
        let moreText = $(`#restContent${schoolId}`);
        let readMoreDots = $(`#readMoreDots${schoolId}`);

        if (!moreText.is(':visible')) {
            readMoreDots.addClass('d-none');
            readMoreButton.text(` ${readLessText}`);
            // moreText.removeClass('d-none');
            moreText.fadeIn(500);
        } else {
            readMoreDots.removeClass('d-none');
            readMoreButton.text(` ${readMoreText}`);
            // moreText.addClass('d-none');
            moreText.fadeOut(100);
        }
    });
}

window.sendNewUnverifiedUserNotificationEmail = (user_id = 0) => {
    let formData = new FormData();
    formData.append('user_id', user_id);
    mainApiAxios.post(`/user-register-notification`, formData);
}

window.sendNewVerifiedUserNotificationEmail = () => {
    mainApiAxios.post(`/user-verified-notification`);
}

$(function(){

    /* ======================= add country code Input ======================= */
    $('#enquireForSchoolModal').on('show.bs.modal', () => {
        const loginUserMobile = $('#eqContactNumber');

        if(loginUserMobile.parent('.iti').length === 0){
            loginUserMobile.intlTelInput(defaultIntlTelInput);
        }
    });

    const enquireForSchoolForm = $('#enquireForSchool');
    enquireForSchoolForm.on('submit', function(e){
       e.preventDefault();
       const contactNumberSelector = $('#eqContactNumber');
       const schoolName = $('#eqSchoolName').val();
       const contactName = $('#eqContactName').val();
       const contactNumber = contactNumberSelector.val();
       const contactEmail = $('#eqContactEmail').val();
       const emirate = $('#eqEmirateSelect').val();
       const message = $('#eqYourMessage').val();
       const contactCountryCode = contactNumberSelector.intlTelInput("getSelectedCountryData").dialCode;
       const contactCountryCodeStr = contactNumberSelector.intlTelInput("getSelectedCountryData").iso2;
       const contactNumberValidate = verifyPhoneNumberFromGoogleScript(contactNumber, contactCountryCodeStr);
       const enquireForSchoolFormRes = $('#enquireForSchoolFormRes');
       const submitBtn = $('#enquireForSchool button[type="submit"]');

       if(contactNumberValidate){
           const formData = new FormData();
           formData.append('school_name', schoolName);
           formData.append('contact_number', `+${contactCountryCode}-${contactNumber}`);
           formData.append('contact_email', contactEmail);
           formData.append('contact_name', contactName);
           formData.append('emirate', emirate);
           formData.append('message', message);
           formData.append('page_source', window.location.href);
           submitBtn.prop('disabled', true).text('submitting...');
           axios.post(`${APP_URL}/api/enquire-school`, formData).then(res => {
               const response = res.data;
               enquireForSchoolFormRes.addClass('text-success text-danger').removeClass('d-none').text(response.msg);
               submitBtn.prop('disabled', false).text('Send');
               enquireForSchoolForm.trigger('reset');
           }).catch(e => {
               const response = e.response.data;
               enquireForSchoolFormRes.addClass('text-danger text-success').removeClass('d-none text-danger').text(response.msg);
               submitBtn.prop('disabled', false).text('Send');
           })
       }else{
           enquireForSchoolFormRes.addClass('text-danger text-danger').removeClass('d-none text-success').text('Invalid Phone number.');
           submitBtn.prop('disabled', false).text('Send');
       }

    });

    const contactNumberSelector = $('#eqContactNumber');
    contactNumberSelector.on('blur', function(){

        const contactNumber = contactNumberSelector.val();
        const contactCountryCode = contactNumberSelector.intlTelInput("getSelectedCountryData").dialCode;
        const contactCountryCodeStr = contactNumberSelector.intlTelInput("getSelectedCountryData").iso2;
        const contactNumberValidate = verifyPhoneNumberFromGoogleScript(contactNumber, contactCountryCodeStr);
        const submitBtn = $('#enquireForSchool button[type="submit"]');
        const enquireForSchoolFormRes = $('#enquireForSchoolFormRes');
        if(!contactNumberValidate){
            submitBtn.prop('disabled', true);
            enquireForSchoolFormRes.addClass('text-danger text-danger').removeClass('d-none text-success').text('Invalid Phone number.');
        }else{
            submitBtn.prop('disabled', false);
            enquireForSchoolFormRes.removeClass('d-none text-danger').text('');
        }

    });

    /* ======================= /add country code Input ======================= */

})
